import React from "react";
import Products from "../components/Products";

const Home = () => {
  return (
    <div>
      <Products />
    </div>
  );
};

export default Home;
